<!-- template v.1 -->
<template>
<div class="col py-3">

            <div class="col-md-12" style="padding:0; text-align:center;margin-bottom:15px">
              <h4 class="card-title" style="text-decoration:underline">Cambio de Horario </h4>
    
            </div>
             <div class="col-md-12" style="padding:0">
            <!-- Profile Image -->
            <div class="card card-info">
              <div class="card-header">
                <h3 class="card-title">Filtros de Empleados</h3>
                
              </div>
              <div class="card-body">
              <div class="col-md-12">
                  <div class="col-md-4 form-org">
                       <div class="form-group ">
                  <label class="col-form-label" >
                    Local</label
                  >
                  <select class="form-control"    v-model="Local" @click="CargaReloj()">
                    <option value="-1" >Todos </option>
                    <option v-for="item in Locales" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                    
                  </select>
                </div>
                <div class="form-group ">
                  <label class="col-form-label" >
                    Reloj</label
                  >
                  <select class="form-control"    v-model="Reloj">
                    <option value="-1"  >Todos </option>
                    <option v-for="item in Relojes" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                    
                  </select>
                </div>
                <div class="form-group ">
                  <label class="col-form-label" >
                    Horario</label
                  >
                  <select class="form-control"    v-model="Horario">
                    <option value="-1"  >Todos </option>
                    <option v-for="item in Horarios" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                    
                  </select>
                </div>
                  </div>
                  <div class="col-md-4 form-org">
                       <div class="form-group">
                  <label class="col-form-label" >
                    Área</label
                  >
                  <select class="form-control"   v-model="Area">
                    <option value="-1"  >Todos </option>
                    <option v-for="item in Areas" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                    
                  </select>
                </div>
                <div class="form-group">
                  <label class="col-form-label" >
                    Estado</label
                  >
                  <select class="form-control"  v-model="Estado">
                     <option value="-1"  >Todos </option>
                    <option v-for="item in Parametros" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                    
                  </select>
                </div>
                 <div class="col-md-12 form-org" style="margin-top: 32px;">
                <div class="input-group">
                   <button type="submit" 
                   class="btn btn-success" 
                   style="width:100%" 
                   @click="Buscar()" >
                   
                   Buscar</button>
                </div>
                </div>
                
                  </div>
                  <div class="col-md-4 form-org">
                    <div class="input-group">
                    <label class="col-form-label" style="width: 100%;">
                    DNI
                    </label>
                    <input type="number"
                    class="form-control"
                    @keypress="MaxNumber($event)"
                    pattern="^[0-9]+"
                    oninput="validity.valid||(value='');"
                    v-model="DNI"
                    placeholder="XXXXXXXXX" 
                    onwheel="this.blur()"
                    step="1-9"
                    min="0"
                    max="99999999"
                    autocomplete="off">
                </div>
                <div class="input-group mb-3">
                    <label class="col-form-label"  style="width: 100%;">
                    Nombres
                    </label>
                    <input type="text" class="form-control" maxlength="50" v-model="Nombres" placeholder="Nombres" >
                    
                </div>
                <div class="col-md-12 form-org" style="margin-top: 16px;">
                <div class="input-group">
                   <button type="submit" 
                   class="btn btn-info" 
                   style="width:100%;color: #fff;" 
                   @click="Cambiar()" >
                   
                   Cambiar</button>
                </div>
                </div>
                  </div>
              </div>
             
               
               
               
               
              </div>
              <!-- /.card-body -->
            </div>
           
          

      </div>
      <div class="col-md-12" style=" margin-top: 15px; float:left;padding:0;margin-bottom: 60px;">
          
          
           <table class="table table-hover table-responsive"  >
                  <thead  class="tabla-asistencia">       
                    <tr >
                        
                      <th ><input type="checkbox" id="todos" @click="CheckAll()" v-if="Empleados != ''"></th>
                      <th >Código</th>
                      <th >DNI</th>
                      <th >Nombre Completo</th>
                      <th >Área</th>
                      <th >Reloj</th>
                      <th >Local</th>
                      <th >Estado</th>
                      <th >Horario</th>
                      <th >Histórico</th>
                   
                     
                    </tr>
                  </thead>
                  
                  <!-- <tbody v-for="(item, index) in ListaEmpleados.filter(Paginador)"   v-bind:key="item" v-bind:index="index" v-show="(pag - 1) * NUM_RESULTS <= index  && pag * NUM_RESULTS > index"> -->
                     <tbody v-for="(item, index) in ListaEmpleados"   v-bind:key="item" v-bind:index="index" @click="selectRow(item)">
                    <!--  <tr v-if="!item.disabled"> -->
                      <tr >
                      <td ><input type="checkbox" v-model="item.nCheck" :checked="(item.nCheck == 1) ? true : false"></td>
                      <td >{{item.nCodigo}}</td>
                      <td >{{item.sDni}}</td>
                      <td >{{item.sNombre}}</td>
                      <td >{{item.sArea}}</td>
                      <td >{{item.sReloj}}</td>
                      <td >{{item.sLocal}}</td>
                      <td >{{item.sEstadoDesc}}</td>
                      <td >{{item.sHorarioDesc}}</td>
                      <td ><button type="button" class="btn btn-info btn-table" @click="Historico(item)">Ver</button></td>


                    
                      
                    </tr>

                    
                  </tbody>
                 
                   
         
                </table>
                <div style="display: flex;align-items: start;  " >
                    <button  @click="setPage(1)" type="button" style="border-radius: 0px;" class="btn btn-primary" >Primero</button>
                    <nav aria-label="Page navigation example" style="    background: transparent !important;">
                      <ul class="pagination">
                        <li class="page-item" v-for="(pageNumber, index) in totalPages" :key="index" v-show="Math.abs(pageNumber - currentPage) <= 5  || pageNumber == totalPages || pageNumber == 0" >
                            <a class="page-link" style="cursor:pointer" @click="setPage(pageNumber)" :class="{current: currentPage === pageNumber, last: (pageNumber == totalPages && Math.abs(pageNumber - currentPage) > 3), first:(pageNumber == 0 && Math.abs(pageNumber - currentPage) > 3)}">
                                {{ pageNumber }} 
                            </a>
                        </li>
                    </ul>
                    </nav>
                </div>
                
        </div>
</div> 
<ModalPeque v-show="ModalPeque.isCambiarHorario" :modalpeque="ModalPeque">  
    <div class="col-md-12" style="float: left;">
        <div class="col-md-12 form-org">
      <div class="form-group">
            <label class="col-form-label"> Nuevo Horario </label>
              <select class="form-control"    v-model="NuevoHorario">
                <option value="-1" >Seleccionar Horario </option>
                <option v-for="item in Horarios" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
              </select>
        </div>
        <div class="form-group" style="float: left">
            <input type="hidden" id="codigo" v-model="codigo" />
            <label class="col-form-label w-100">Fecha y Hora Vigencia</label>
                <input type="date" v-model="NuevaFecha" min="1990-01-01" max="2999-12-31" class="form-control" style="width: 53%;float: left;">
                <input type="time" v-model="NuevaHora" class="form-control" style="    width: 40%; float: right; text-align: center;"  > 
        </div>
        <div class="form-group">
            <label class="col-form-label"> Comentario </label>
                <textarea type="text" maxlength="200" v-model="ComentarioHorario" class="form-control"  ></textarea>
        </div>
        <div class="modal-footer botones-modal">
        <button type="button" class="btn btn-success guardar-modal" @click="CambioHorario()" >Aceptar</button>
        <button type="button" class="btn btn-danger cancelar-modal" @click="ModalPeque.isCambiarHorario = false"> Cancelar</button>
      </div>
        </div>
     
        
       
        </div>
        
        
        
</ModalPeque>

<ModalPeque  v-show="ModalPeque.isCambiarVigencia" :modalpeque="ModalPeque">  
    <div class="col-md-12" style="float: left;">
        <div class="col-md-12 form-org">
        <div class="form-group" style="float: left">
            <label class="col-form-label">Fecha y Hora Vigencia</label>
                <input type="date"  v-model="NuevaFechaVig" min="1990-01-01" max="2999-12-31" class="form-control" style="width: 53%;float: left;" >
                <input type="time" v-model="NuevaHoraVig" class="form-control" style="    width: 40%; float: right; text-align: center;"  > 
        </div>

        <div class="modal-footer botones-modal">
        <button type="button" class="btn btn-success guardar-modal" @click="EditHorarioVig()">Aceptar</button>
        <button type="button" class="btn btn-danger cancelar-modal" @click="ModalPeque.isCambiarVigencia = false"> Cancelar</button>
      </div>
        </div>
     
        
       
        </div>
</ModalPeque>

<ModalPeque  v-show="ModalPeque.isEliminarHorario" :modalpeque="ModalPeque">  
    <div class="col-md-12" style="float: left;">
        <div class="col-md-12 form-org">
        <div class="form-group contenedor-msje" >
            <input type="hidden" id="codigoHorario" v-model="codigo" />
            <label class="col-form-label">¿Está seguro que desea eliminar horario seleccionado?</label>
        </div>

        <div class="modal-footer botones-modal">
        <button type="button" class="btn btn-success guardar-modal" @click="EliminarHorario()">Sí</button>
        <button type="button" class="btn btn-danger cancelar-modal" @click="ModalPeque.isEliminarHorario = false"> No</button>
      </div>
        </div>
     
        
       
        </div>
</ModalPeque>


<ModalGrande v-show="ModalGrande.isVerEmpleados" :modalgrande="ModalGrande">  
    <div class="col-md-12 form-org">

        <input type="hidden" id="nCodigo" v-bind:value="nCodigo" />
        
        <div class="table-wrapper-scroll-y my-custom-scrollbar">
          <table class="table table-hover table-responsive" id="tableId" >
            <thead  class="tabla-asistencia">       
              <tr >
                <th >Nombre</th>
                <th >Turno</th>
                <th >Tolerancia Ing. (min)</th>
                <th >Ingreso / Salida</th>
                <th >Refrigerio (min)</th>
                <th >Estado</th>
                <th >Inicio Vig.</th>
                <th >Usuario</th>
                <th >Comentario</th>
                <th >Acción</th>

              
                
              </tr>
            </thead>
            
              <tbody v-for="(item, index) in HistorialEmpleadosPaginador"   v-bind:key="item" v-bind:index="index" >
              <tr >
              
                <td >{{item.sNombre}}</td>
                <td >{{item.sTurnoDesc}}</td>
                <td >{{item.nToleranciaIng}}</td>
                <td >{{item.sIngresoSalidaDesc}}</td>
                  <td >{{item.sRefrigerioDesc}}</td>
                <td >{{item.sEstadoDesc}}</td>
                <td >{{item.sInicioVigencia}}</td>
                <td >{{item.sUsuario}}</td>
                <td >{{item.sComentario}}</td>
                <td v-if="item.nEstado ==3" > 
                      <button  style="display:none" type="button" class="btn btn-info btn-table" @click="ModalEditHorario(item)">
                        Editar
                      </button>
                      
                      <button style="display:none" type="button" class="btn btn-danger btn-table" @click="ModalEliminarHorario(item)">
                        Eliminar
                      </button>
                </td>
                <td v-else> 
                      <button  type="button" class="btn btn-info btn-table" @click="ModalEditHorario(item)">
                        Editar
                      </button>
                      
                      <button type="button" class="btn btn-danger btn-table" @click="ModalEliminarHorario(item)">
                        Eliminar
                      </button>
                </td>
                

              </tr>
            </tbody>
          </table>
          <div style="display: flex;align-items: start;  " >
              <button  @click="setPageHistorial(1)" type="button" style="border-radius: 0px;" class="btn btn-primary" >Primero</button>
              <nav aria-label="Page navigation example" style="    background: transparent !important;">
                <ul class="pagination">
                  <li class="page-item" v-for="(pageNumberHistorial, index) in totalPagesHistorial" :key="index" v-show="Math.abs(pageNumberHistorial - currentPageHistorial) <= 5  || pageNumberHistorial == totalPagesHistorial || pageNumberHistorial == 0" >
                      <a class="page-link" style="cursor:pointer" @click="setPageHistorial(pageNumberHistorial)" :class="{current: currentPageHistorial === pageNumberHistorial, last: (pageNumberHistorial == totalPagesHistorial && Math.abs(pageNumberHistorial - currentPageHistorial) > 3), first:(pageNumberHistorial == 0 && Math.abs(pageNumberHistorial - currentPageHistorial) > 3)}">
                          {{ pageNumberHistorial }} 
                      </a>
                  </li>
                </ul>
              </nav>
          </div>
        </div>
      </div>
</ModalGrande>  
</template>
<script>
export default {
     props: ["content"],

  data: function () {
    return {
      Locales:[],
      Areas:[],
      Relojes:[],
      Parametros:[],
      Horarios:[],
      Horario:-1,
      Local:-1,
      Area:-1,
      Reloj:-1,
      Estado:1,
      alertax:false,
      DNI:"",
      Nombres:"",
      Empleados:[],
      ListaEmpleados:[],
      itemsPageDefault : 10,
      itemsPageDefaultHistorial : 10,
      NuevoHorario:"",
      codigo: "",
      NuevaHora:"",
      NuevaFecha:"",
      NuevaFechaHoraVig: "",
      NuevaFechaVig: "",
      NuevaHoraVig: "",
      ComentarioHorario:"",
      HistorialEmpleados:[],
      HistorialEmpleadosPaginador:[],
      resultCount: 0,
      currentPage: 0,
      resultCountHistorial: 0,
      currentPageHistorial: 0,
      Data:[],
      ModalPeque : {
        isCambiarHorario : false,
        isCambiarVigencia: false,
        isEliminarHorario: false
      },
      ModalGrande : {
        isVerEmpleados : false,
      },
      

      
    };
  },
  computed: {
        totalPages: function() {
          return Math.ceil(this.resultCount / this.itemsPageDefault)
        },
        totalPagesHistorial: function() {
          return Math.ceil(this.resultCountHistorial / this.itemsPageDefaultHistorial)
        }
  },
  mounted(){
    this.content.login = false;
    this.content.sistema = true;

    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/ListarLocales?nCodigo=-1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Locales = response.data.oListaLocales;
        })
     this.axios
        .get(gestion + "/HorarioListarCombo?nCodigo=-1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Horarios = response.data.lstHorarios;
        })
    this.axios
        .get(gestion + "/ListarAreas?nCodigo=-1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Areas = response.data.oListaAreas;
        })
    this.axios
        .get(gestion + "/ListarParametrosHijos?nCodigo=1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Parametros = response.data.oListaParametros;
        })
    
  },
  methods: {
    Historico(item){
    this.ModalGrande.isVerEmpleados =true;
    this.ModalGrande.titulo = "Historial de Horarios Asigandos al Empleado : " +item.sNombre;
    let gestion = this.$store.state.menu;
    this.nCodigo = item.nCodigo;

    this.nEstado = item.nEstado;
    


    this.axios
        .get(gestion + "/ListarHorariosHistorico?nCodEmp="+item.nCodigo, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.HistorialEmpleados = response.data.lstHorarios;


          const countUser = this.HistorialEmpleados.filter(resp => !resp.disabled);
          this.resultCountHistorial = countUser.length;
          this.currentPageHistorial = 0;
          if (this.currentPageHistorial >= this.totalPagesHistorial) {
              this.currentPageHistorial = this.totalPagesHistorial
            }
          var index = this.currentPageHistorial * this.itemsPageDefaultHistorial;      
          this.HistorialEmpleadosPaginador = this.HistorialEmpleados.slice(index,index+this.itemsPageDefaultHistorial);

        })
    }, 
    HistorialEmplead(){
      let gestion = this.$store.state.menu;

      let nCodigo = document.getElementById("nCodigo").value;
      
      this.axios
        .get(gestion + "/ListarHorariosHistorico?nCodEmp="+nCodigo, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.HistorialEmpleadosPaginador = response.data.lstHorarios;
        })
      
    },
    ModalEditHorario(item){
    this.ModalPeque.isCambiarVigencia =true;
    this.ModalPeque.titulo = "Actualizar Vigencia : " +item.sNombre;

    this.NuevaFechaHoraVig = item.sInicioVigencia;
    //console.log(this.NuevaFechaHoraVig);

    this.splitFechaCompleta = this.NuevaFechaHoraVig.split(" ");
    //console.log(this.splitFechaCompleta);
    this.NuevaFecha = this.splitFechaCompleta[0];
    //this.NuevaFechaVig = '2021-09-12';
    //console.log(this.NuevaFecha);

    this.splitNuevaFecha = this.NuevaFecha.split("/");
    //console.log(this.splitNuevaFecha);

    var day = this.splitNuevaFecha[0];
    var month = this.splitNuevaFecha[1];
    var year = this.splitNuevaFecha[2];

    this.NuevaFechaVig =  year + '-' + month + '-' + day;

    //console.log(this.NuevaFechaVig);

    this.NuevaHoraVig = this.splitFechaCompleta[1];
    //console.log(this.NuevaHoraVig);

    this.codigo = item.nCodigo;
    
    },
    ModalEliminarHorario(item){
      this.ModalPeque.isEliminarHorario =true;
      this.ModalPeque.titulo = "Eliminar Horario : " +item.sNombre;

      this.codigo = item.nCodigo;
      console.log(this.codigo);
    },
    EliminarHorario(){
      var codigo = document.getElementById('codigoHorario').value;
      const formData = new FormData();
      formData.append('nDetalle', codigo);

      let gestion = this.$store.state.menu;

      this.axios
        .post(gestion + "/BorrarHorarioHistxEmp",formData, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
          const data_res = response.data.satisfactorio;
          this.load=false;
          this.ModalPeque.isEliminarHorario=false;
          //this.ModalGrande.isVerEmpleados=false;
          this.HistorialEmplead();

          if(data_res == true){
            this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Se eliminó el horario seleccionado',
            icon: 'success',
            
            });
          }
          else {
          this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: response.data.message,
            icon: 'error',
            
            });  
          }
          
        })

    },
    EditHorarioVig(){
    
    var codigo = document.getElementById('codigo').value;
    var JoinFechaHora = this.NuevaFechaVig + ' ' + this.NuevaHoraVig;
      
    
    const formData = new FormData();
    formData.append('nDetalle', codigo);
    formData.append('sFecha', JoinFechaHora);

    
    
    let gestion = this.$store.state.menu;
    this.axios
        .post(gestion + "/EditarFechaInicioVigHist",formData, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {

          const data_res = response.data.satisfactorio;
          this.load=false;
          this.ModalPeque.isCambiarVigencia=false;
          //this.ModalGrande.isVerEmpleados=false;
          this.HistorialEmplead();

          if(data_res == true){
            this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Se actualizó su fecha de vigencia',
            icon: 'success',
            
            });
          }
          else {
          this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: response.data.message,
            icon: 'error',
            
            });  
          }
          
        })
        
    },
    CambioHorario(){
    this.Data = this.Empleados.filter((item)=>{
        return item.nCheck == true
        });
     
        var codigocheck = "";
        this.Data.forEach((el) => {
              codigocheck +=
                ","+
                el.nCodigo;
                
        });
        const datacheck = codigocheck.substring(1);

    if(this.NuevoHorario == -1){
    this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: 'Debe seleccionar un horario',
          icon: 'error',
          
          }); 
    return;
    }
    
    let gestion = this.$store.state.menu;
    var bodyFormData = new FormData();
    bodyFormData.append("nEmpleados", datacheck);
    bodyFormData.append("sHora", this.NuevaHora);
    bodyFormData.append("sFecha", this.NuevaFecha);
    bodyFormData.append("nIdHorario",this.NuevoHorario );
    bodyFormData.append("sComentario", this.ComentarioHorario);
    this.axios.post(gestion + "/HorarioAsignarMasivo", bodyFormData, {
        headers: {
          Authorization: "Bearer " + localStorage.token,
          "Content-Type": "multipart/form-data",
        }
        })
        .then((response) => {
        const data_res = response.data.satisfactorio;
        this.load=false;
        if (data_res == true) { 
        this.Buscar();
        this.ModalPeque.isCambiarHorario=false;
        this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: response.data.message,
          icon: 'success',
          
          });
        }
        else {
        this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: response.data.message,
          icon: 'error',
          
          });  
        }
         
      });
    },
    Cambiar(){
      this.ModalPeque.isCambiarHorario=true;
      this.ModalPeque.titulo = 'Asignar Nuevo Horario';
      this.NuevoHorario = -1;
      this.NuevaHora = "";
      this.NuevaFecha = "";
      this.ComentarioHorario = "";
    
    },
    CheckAll(){
    if(document.getElementById("todos").checked){
    var check = true
    for (var i = 0; i < this.Empleados.length; i++) {
      this.Empleados[i].nCheck = check;
    }
    }
    else {
    var check = false
    for (var i = 0; i < this.Empleados.length; i++) {
      this.Empleados[i].nCheck = check;
    }
    }
    },
    selectRow(item){
            if (item.sCheck == 1) {
                item.sCheck = 0;
            }else{
                item.sCheck = 1;
            }  
            
    },
    Buscar(){
    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/EmpleadosListar?nLocal="+this.Local+"&nReloj="+this.Reloj+
        "&nArea="+this.Area+"&nEstado="+this.Estado+"&nHorario="+this.Horario+
        "&sNombre="+this.Nombres+"&sDni="+this.DNI, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Empleados = response.data.lstEmpleado;

          const countUser = this.Empleados.filter(resp => !resp.disabled);
          this.resultCount = countUser.length;
          this.currentPage = 0;
          if (this.currentPage >= this.totalPages) {
                this.currentPage = this.totalPages
          }
          var index = this.currentPage * this.itemsPageDefault;      
          this.ListaEmpleados = this.Empleados.slice(index,index+this.itemsPageDefault);

          
        })

    
    },
     setPage: function(pageNumber) {
            this.currentPage = pageNumber;
 
        
            if (this.currentPage >= this.totalPages) {
                this.currentPage = this.totalPages
                
            }
            var index = (this.currentPage - 1) * this.itemsPageDefault;
            this.ListaEmpleados = this.Empleados.filter(resp => !resp.disabled ).slice(index, index + this.itemsPageDefault);
        },
    setPageHistorial: function(pageNumberHistorial) {
            this.currentPageHistorial = pageNumberHistorial;
 
        
            if (this.currentPageHistorial >= this.totalPagesHistorial) {
                this.currentPageHistorial = this.totalPagesHistorial
                
            }
            var index = (this.currentPageHistorial - 1) * this.itemsPageDefaultHistorial;
            this.HistorialEmpleadosPaginador = this.HistorialEmpleados.filter(resp => !resp.disabled ).slice(index, index + this.itemsPageDefaultHistorial);
    },
    CargaReloj(){
    const Reloj = this.Local;
    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/ListarRelojes?nCodigo="+ Reloj, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Relojes = response.data.oListaRelojes;
        })
    },
    MaxNumber : function (evt) {
          evt = (evt) ? evt : window.event;
          const value = evt.target.value;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          
           if ( value.length < 8 && (charCode >= 48 && charCode <= 57) ) {
            return true;
          }else{
          this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: 'Su DNI debe contar con 8 dígitos',
          icon: 'error',
          
          });
            evt.preventDefault();
          }
    },
    
   
        

  },
}
</script>

<style scoped>
  .my-custom-scrollbar {
    position: relative;
    height: 440px;
    overflow: auto;
  }
  .table-wrapper-scroll-y {
    display: block;
  }
  .contenedor-msje{
    text-align: center;
    font-weight: 500;
  }

</style>